module.exports = __webpack_public_path__ + "img/google.5a62bb53.png";